import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./styles/main.scss";
import AppRoutes from "./AppRoutes";
import { store } from "./store";
import { persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RouteErrorBoundary from "./components/ApplicationErrorBoundary";
import GlobalTitleTooltip from "./components/GlobalTitleTooltip";
import { useInterfacePreferences } from "./hooks/useInterfacePreferences";
import LanguageBootstrap from "./i18n/LanguageBootstrap";
import {
  applyDocumentLanguage,
  getInitialLanguagePreference
} from "./i18n/language";

const restoreLanguageBeforeRender = () => {
  const preference = getInitialLanguagePreference();
  applyDocumentLanguage(preference.language);
  store.dispatch({ type: "setLanguage", payload: preference.language });
};

export const AppToastContainer = () => {
  const { toastNotifications } = useInterfacePreferences();

  useEffect(() => {
    if (toastNotifications) return;
    toast.dismiss();
    toast.clearWaitingQueue?.();
  }, [toastNotifications]);

  return (
    <ToastContainer
      limit={3}
      pauseOnFocusLoss={false}
      aria-hidden={!toastNotifications}
      style={toastNotifications ? undefined : { display: "none" }}
    />
  );
};

const ApplicationShell = () => {
  const { motionEffects } = useInterfacePreferences();

  return (
    <BrowserRouter>
      <div className={`App${motionEffects ? "" : " motion-effects-disabled"}`}>
        <RouteErrorBoundary>
          <AppRoutes />
        </RouteErrorBoundary>
        <GlobalTitleTooltip />
        <AppToastContainer />
      </div>
    </BrowserRouter>
  );
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
        onBeforeLift={restoreLanguageBeforeRender}
      >
        <LanguageBootstrap>
          <ApplicationShell />
        </LanguageBootstrap>
      </PersistGate>
    </Provider>
  );
}

export default App;
